import baustein from "baustein";
import { ReactTooltip } from "web/react/components/tooltip/tooltip";
import analytics from "web/script/analytics/analytics";
import InstantNotification from "web/script/components/instant-notification";
import "web/script/components/tracked-link";
import userProfiler from "web/script/modules/userprofiler";
import { isMobile } from "web/script/modules/utils";
import renderReactComponentInDocument from "web/script/utils/render-react";

export default baustein.register("instant-feedback", {
    defaultOptions: {
        area: "",
        direction: "bottom",
        category: "InstantFdbk",
        message: "",
        autoShow: undefined,
        autoHide: undefined,
    },

    init() {
        if (this.options.area === "heart") {
            this.options.category = `${this.options.category}_save`;
        } else if (this.options.area === "saved-search") {
            this.options.category = `${this.options.category}_DU`;
        }
        this.isMobile = isMobile();
    },

    show() {
        if (!userProfiler.isLoggedIn()) {
            return;
        }

        if (
            (this.options.area === "heart" && userProfiler.getHeartNotificationShown()) ||
            (this.options.area === "saved-search" &&
                userProfiler.getSavedSearchtNotificationShown())
        ) {
            return;
        }

        const parentClassName = this.el.parentElement.className;

        if (this.isMobile && parentClassName.includes("app-header-bar")) {
            return;
        } else if (!this.isMobile && parentClassName.includes("tabbed-bottom-navigation")) {
            return;
        }

        if (this.isMobile) {
            this.showTooltip();
        } else {
            this.showNotification();
        }
    },

    onInsert() {
        this.render();
    },

    markAsShown() {
        if (this.options.area === "heart") {
            userProfiler.setHeartNotificationShown();
        } else if (this.options.area === "saved-search") {
            userProfiler.setSavedSearchtNotificationShown();
        } else {
            throw Error(
                "Did not receive correct 'area' set when initializing instant-feedback component"
            );
        }
    },

    showNotification() {
        // analytics event is triggered withing the InstantNotification component
        const instantNotification = new InstantNotification({
            icon: this.options.area,
            message: this.options.message,
            category: this.options.category,
        });
        instantNotification.appendTo(document.body);
        this.markAsShown();
    },

    showTooltip() {
        this.options.autoShow = 0.001;
        this.options.autoHide = 5;
        this.markAsShown();
        this.render();
    },

    render() {
        if (this.isMobile) {
            const onShow = () => analytics.event(this.options.category, "shown", null, true);
            const onHide = () => analytics.event(this.options.category, "AutoHide", null, true);
            const onClose = () => analytics.event(this.options.category, "Clicked", "Close");

            renderReactComponentInDocument(
                ReactTooltip,
                {
                    content: this.options.message,
                    children: this.el.innerHTML,
                    direction: this.options.direction,
                    manual: true,
                    autoShow: this.options.autoShow,
                    autoHide: this.options.autoHide,
                    onShow,
                    onHide,
                    onClose,
                    theme: "light",
                    withCloseButton: true,
                },
                this.el
            );
        }
    },
});
